// Blue Cat personalised-video add-on option styling.
document.addEventListener('change', (event) => {
  const input = event.target.closest('input[name="bc_video_addon"]');
  if (!input) return;
  const root = input.closest('[data-bluecat-video-addon]');
  if (!root) return;
  root.querySelectorAll('.bc-video-addon__option').forEach((option) => option.classList.remove('is-selected'));
  input.closest('.bc-video-addon__option')?.classList.add('is-selected');
});
